import React, { useEffect, useState } from "react";
import {
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  FormControl,
  Button,
  Grid,
} from "@mui/material";
import axiosInstance from "../services/axiosInstance";

// Create a styled Select component with custom styles
// const StyledSelect = styled(Select)({
//   "& .MuiPaper-root": {
//     zIndex: 99999,
//   },
//   "& .MuiPopover-paper": {
//     zIndex: 99999,
//   },
//   "& .MuiMenu-paper": {
//     zIndex: 99999,
//   },
// });

const SelectWithCheckmarks = ({
  userModulePermissions,
  setUserModulePermissions,
}) => {
  const [totalUserModules, setTotalUserModules] = useState([]);

  useEffect(() => {
    fetchUserModulePermissions();
  }, []);

  const fetchUserModulePermissions = async () => {
    const response = await axiosInstance.get(
      "/api/UserManagement/getAllModulePermissions"
    );
    setTotalUserModules(response);
  };

  const handleSelectChange = (event) => {
    const selectedNames = event.target.value;
    const newSelectedValues = totalUserModules.filter((module) =>
      selectedNames.includes(module.applicationModuleName)
    );
    setUserModulePermissions(newSelectedValues);
  };

  return (
    <div className="w-full min-w-[410px] select_checkbox">
      <FormControl fullWidth>
        <Select
          labelId="select-label"
          id="select"
          className="appearance-none !border-none h-12 !border-gray !leading-normal !text-2xl !w-full bg-white !rounded-lg !py-3 !px-2 !text-gray-600 !placeholder:text-gray-600 !hover:border-blue-600 !focus:border-blue-600 !focus:outline-none shadow-none"
          multiple
          MenuProps={{
            sx: {
              zIndex: 10000,
              "& .MuiMenu-paper": {
                zIndex: 100000,
                position: "absolute",
              },
              "& .MuiPopover-paper": {
                zIndex: 100000,
                position: "absolute",
              },
            },
          }}
          value={userModulePermissions.map(
            (item) => item.applicationModuleName
          )}
          onChange={handleSelectChange}
          renderValue={(selected) => {
            if (selected.length === 0) return "Permissions";
            return selected.join(", ");
          }}
        >
          {totalUserModules.map((option) => (
            <MenuItem
              key={option.applicationModuleId}
              value={option.applicationModuleName}
              className="p-5 gap-4"
            >
              <Checkbox
                checked={userModulePermissions.some(
                  (selectedItem) =>
                    selectedItem.applicationModuleName ===
                    option.applicationModuleName
                )}
                className="w-4 h-4 border border-gray-500"
              />
              <ListItemText
                primary={option.applicationModuleName}
                className="text-gray-700 font-interRegular"
              />
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Wrapper for selected items to enable scrolling */}
      <div className="mt-2 max-h-20 overflow-y-auto">
        <Grid container spacing={1}>
          {userModulePermissions.map((value) => (
            <Grid item key={value.applicationModuleId}>
              <Button
                variant="solid"
                size="small"
                className="!bg-[#EFEFEF] !capitalize !rounded-md !leading-normal !text-2xl !px-[6px] !pb-[3px] !pt-[5px] !border-none !text-gray-500"
              >
                {value.applicationModuleName}
              </Button>
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  );
};

export default SelectWithCheckmarks;
